export class SampleFarmDto {
  id: string;
  code: string;
  label: string;
  postcode: string;
  region: string;
}